import SiteConfigs from '../../config/sites'

const initialState = {
  pageIsOffCanvas: false,
  pageCanvasDirection: null,
  isModalOpen: false,
  openModalType: null,
  openModalData: null,
  modalMessages: null,
  toggledPanelIds: [],
  selectedItemId: null,
  offsetTop: null,
  isSidebarOpen: true
}

/**
 * UI state store action handler
 * @param  {Object} action Object
 * @param  {Object} state  Object
 * @return {Object} new State
 */
export default (state = initialState, action) => {
  switch (action.type) {
    case 'toggleOffCanvas': {
      const direction = action.payload
      return {
        ...state,
        pageIsOffCanvas: !state['pageIsOffCanvas'],
        pageCanvasDirection: direction
      }
    }

    case 'closeModal':
      return {
        ...state,
        isModalOpen: false,
        openModalType: null,
        openModalData: null,
        modalMessages: null
      }

    case 'openModal': {
      const { type, payload } = action.payload
      return {
        ...state,
        isModalOpen: true,
        openModalType: type,
        openModalData: payload
      }
    }

    case 'showModalMessage':
      return {
        ...state,
        modalMessages: action.payload
      }

    case 'dismissModalMessage':
      return {
        ...state,
        modalMessages: null
      }

    case 'togglePanel': {
      const { toggledPanelIds } = state
      const panelId = action.payload
      const panelToggled = toggledPanelIds.indexOf(panelId) >= 0

      let ids = panelToggled
        ? toggledPanelIds.filter(id => {
            return id !== panelId
          })
        : [...toggledPanelIds, panelId]

      return { ...state, toggledPanelIds: ids }
    }

    case 'loadSiteConfigs': {
      const { currentSite } = action.payload

      const currentSiteConfig = SiteConfigs[currentSite]
      const isCurrentSiteSidebarOpen = !currentSiteConfig.hide_sidebar_by_default
      return { ...state, isSidebarOpen: isCurrentSiteSidebarOpen }
    }

    case 'toggleSidebar': {
      const { isSidebarOpen } = state

      return { ...state, isSidebarOpen: !isSidebarOpen }
    }

    case 'selectItem': {
      const { selectedItemId } = state
      const itemId = action.payload

      let id = selectedItemId === itemId ? null : itemId

      return { ...state, selectedItemId: id }
    }

    case 'offsetTop': {
      const { offsetTop } = action.payload

      return { ...state, offsetTop }
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./common/reducers/layout.js